import { MutationTree } from 'vuex';
import { ISearchResult } from '../types/search-result';
import { ESearchMutation } from '@/topbar/search/store/search.constants';
import { ISearchState } from '@/topbar/search/store/search.types';

export const mutations: MutationTree<ISearchState> = {
  [ESearchMutation.SetState](state: ISearchState, defaultState: ISearchState) {
    state.query = defaultState.query;
    state.result = defaultState.result;
    state.loaded = defaultState.loaded;
    state.loading = defaultState.loading;
    state.showSearchInput = defaultState.showSearchInput;
  },
  [ESearchMutation.SetQuery](state: ISearchState, query: string) {
    state.query = query;
  },
  [ESearchMutation.SetSearchInputVisibility](state: ISearchState, show: boolean) {
    state.showSearchInput = show;
  },
  [ESearchMutation.SetLoading](state: ISearchState, loading: boolean) {
    state.loading = loading;
  },
  [ESearchMutation.SetLoaded](state: ISearchState, loaded: boolean) {
    state.loaded = loaded;
  },
  [ESearchMutation.SetResult](state: ISearchState, result: ISearchResult) {
    state.result = result;
  },
};
